import React from 'react';
import NullspaceSlider from './NullspaceSlider';
import LiveDecoder from './LiveDecoder';
import ArchitectureDiagram from './ArchitectureDiagram';
import SyncedScrubber from './SyncedScrubber';
import LayerReveal from './LayerReveal';
import WeightDistribution from './WeightDistribution';

export const vizComponents: Record<string, React.FC<{ source?: string }>> = {
  'nullspace-slider': NullspaceSlider,
  'live-decoder': LiveDecoder,
  'architecture-diagram': ArchitectureDiagram,
  'synced-scrubber': SyncedScrubber,
  'layer-reveal': LayerReveal,
  'weight-distribution': WeightDistribution,
};

export { NullspaceSlider, LiveDecoder, ArchitectureDiagram, SyncedScrubber, LayerReveal, WeightDistribution };
